module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_3-9691472caa2ff38db0af05cfafda703d.svg";